var winstatus = 'scrollbars=yes,menubar=no,height=800,width=1024,resizable=yes,toolbar=no,location=no,status=no';

var $trsMap = {};
var $flightList = {};
var flightOpen = {};

var userLogged = false;

var datePickerDateFormat = "dd.mm.yy";
var datePickerDateFormatDD = "dd.mm.yy DD";

$(document).mouseup(function(event) {

	var container = $('div.selCityBox');
	if (!container.is(event.target) & container.has(event.target).length === 0) {
		container.hide('fade');
	}
});

$(document)
		.ready(
				function() {

					$("#searchForm").validate();

					$trsMap["departure"] = $("table[flightType=departure]>tbody>tr");
					$trsMap["return"] = $("table[flightType=return]>tbody>tr");
					
					$flightList = $("#link-table [gr=a]");
					
					$(document).on("change",".departureFlight,.returnFlight",groupFlights);

					var $clickedButton = $();
					$(document).on("click",".priceDetailButton",function() {
						
						var $button = $clickedButton.length > 0 ? $clickedButton : $(this);
						var $flightRow = $button.closest("tr[gr=a]");

						var providerKey = $button.attr("providerKey");
						if (!checkForPriceDeatil($button)) {
							alert(FmtMessage.getMessage('js.search.warning.infant') + "\n\n" + FmtMessage.getMessage('js.search.warning.child'));
						} else if (checkTotalPax($button) > 0) {
							alert(sprintf(FmtMessage.getMessage('js.search.warning.paxcount'), checkTotalPax($button)));
						} else if (!checkFreeSeat($button)) {
							alert(FmtMessage.getMessage('js.error.not.enough.freeseats'));
						} else if (Flight.direction==2 && $("#returnDate").val() != null && $("#returnDate").val().length > 1 && !checkReturnFlightTime($button)) {
							alert(FmtMessage.getMessage('js.search.warning.returnFlightDeparture'));
						} else if (!Flight.canDoLastHourRes  && isLastHourFlight($button)) {
							alert(FmtMessage.getMessage('js.search.warning.lastHourFlight'));
						} else {
							// if ('OnurAir' == $('#providerKey').val()) {
							if ('OnurAir' == providerKey) {
								showOnurAir();
								return;
							} else {

								$("#itinarary_departure").val($button.attr("segmentNames"));
								$("#itinarary_return").val($button.attr("rSegmentNames"));
								$("#officeId").val($button.attr("officeId"));

								var providerId = $button.attr("providerid");
								var flightDeparture = $button.attr("flightdeparture");
								var flightArrival = $button.attr("flightarrival");
								var faretype = $button.attr("faretype");

								setProvidersPassengers(providerId, flightDeparture, flightArrival, faretype);

								openLoaderBox();
		
								$("#priceDetailForm").submit();
								return true;

							}
						}
					});

					$("#searchForm").submit(function() {
						var formValid = $("#searchForm").valid();
						if (formValid)
							openFlightLoaderBox();
						else
							return false;

						return true;
					});

				});

function checkForPriceDeatil($button) {

	var adult = $("#numAdult").val();
	var child = $("#numChild").val();
	var infant = $("#numInfant").val();
	var student = $("#numMilitary").val();
	var military = $("#numStudent").val();
	var senior = $("#numSenior").val();
	var young = $("#numYoung").val();

	var totalPax = parseInt(adult) + parseInt(child) + parseInt(infant) + parseInt(student) + parseInt(military) + parseInt(senior) + parseInt(young);

	var cntNonFlyingAloneINF = 0;
	var cntNonFlyingAlonePax = 0;

	var providerId = $button.attr("providerid");
	var flightdeparture = $button.attr("flightdeparture");
	var flightarrival = $button.attr("flightarrival");
	var faretype = $button.attr("faretype");

	if(providerDefMap[providerId] == null)
		setProvidersPassengers(providerId, flightdeparture, flightarrival, faretype);
	
	if(providerDefMap[providerId] != null){
		
		if (!providerDefMap[providerId].isChildFlyingAlone)
			cntNonFlyingAlonePax = parseInt(cntNonFlyingAlonePax) + parseInt(child);
		
		if (!providerDefMap[providerId].isInfantFlyingAlone)
			cntNonFlyingAloneINF = parseInt(cntNonFlyingAloneINF) + parseInt(infant);

	} else { // For general case, Adult/Child/Infant
		cntNonFlyingAlonePax = parseInt(child);
		cntNonFlyingAloneINF = parseInt(infant);
	}

	if (parseInt(cntNonFlyingAloneINF) > (totalPax - cntNonFlyingAlonePax - cntNonFlyingAloneINF))
		return false;

	if (cntNonFlyingAlonePax > 0 && (totalPax - cntNonFlyingAloneINF - cntNonFlyingAlonePax) < 1)
		return false;

	return true;

}

function checkAdultDiscountType() {

	// using for history.back()
	$("#numAdult").val($("#totalAdult").val());

	var adult = $("#numAdult").val();
	var student = $("#paxMilitary").val();
	var military = $("#paxStudent").val();
	var senior = $("#paxSenior").val();
	var young = $("#paxYoung").val();

	var adultDiscountTypeCount = parseInt(student) + parseInt(military) + parseInt(senior) + parseInt(young);

	if (parseInt(adultDiscountTypeCount) > parseInt(adult)) {
		return false;
	} else {
		return true;
	}
}

function groupFlights(){			
	
	var itemRow = $(this).closest("tr[gr=a]");
	
	var depChecked = itemRow.find(".departureFlight").is(":checked");
	var retChecked = itemRow.find(".returnFlight").is(":checked");
	
	$flightList.attr("data-visible",true);
	
	$flightList.each(function(){
		
		var $that = $(this);
		
		if(depChecked){
			
			if($that.attr("flightId") == itemRow.attr("flightId") &&
					$that.attr("fareIndex") == itemRow.attr("fareIndex")){
				$that.find(".departureFlight").prop("checked",true);
			} else {
				$that.next().andSelf().attr("data-visible","false");
				$that.find(".departureFlight").prop("checked",false);
			}
			
		} else {
			$that.find(".departureFlight").prop("checked",false);
		}
		
		if(retChecked){
		
			if($that.attr("rflightId") == itemRow.attr("rflightId") &&
					$that.attr("rfareIndex") == itemRow.attr("rfareIndex")){
				$that.find(".returnFlight").prop("checked",true);
			} else {
				$that.next().andSelf().attr("data-visible","false");
				$that.find(".returnFlight").prop("checked",false);
			}
		
		} else {
			$that.find(".returnFlight").prop("checked",false);
		}
		
	});
	
	applySearchFilter();
	pageIndex = 0;
	refreshTable();	
}

function transferAirportInfo(code, name, city) {
	var airportString = code + " " + name + ", " + city;
	$('input.' + direction).val(airportString);
	$(".selCityBox." + direction).toggle();
}

function showPassengers() {
	showCipOption();
	$("#passengerCount").show();
}

function isContraryProvider() {

//	var depKey = $('input[name=itinarary_departure]:checked').attr("providerKey");
//	var retKey = $('input[name=itinarary_return]:checked').attr("providerKey");
//
//	var ret = retKey !== undefined && depKey != retKey;
//	return ret;
	
	return false;
}

function showCipOption($flightRow) {
	if (eval($flightRow.attr("hasCip") && eval($flightRow.attr("rHasCip")))){
		$("#wantCip").show();
		return true;
	}
	else {
		$("#wantCip").hide();
		return false;
	}
}

//function hasCip(flightType) {
//	if ($trsMap[flightType].length == 0)
//		return true;
//
//	$input = $trsMap[flightType].find("input:checked");
//	if ($input.size() == 0)
//		return false;
//	else {
//		var index = $input.attr("index");
//		var hasCip = $trsMap[flightType].filter("[index=" + index + "]").attr("hasCip");
//		return eval(hasCip);
//	}
//}

function extractPrice(node) {
	var attribute = node.attributes["class"];
	var class1 = attribute.nodeValue;
	var text = "";
	if (class1 == "infoButtons") {
	} else if (class1 == "sr-stops") {
		text = $(node).text();
	} else {
		text = $(node).find("span:first").html();
	}

	return text;
}

function searchAnotherDay(dep, ret) {
	$("#dayDep").val(dep);
	$("#dayRet").val(ret);
	openFlightLoaderBox();
	$("#searchForm").submit();
}

function switchAirports() {
	var fromAirport = $("[name=fromAirport]").val();
	var toAirport = $("[name=toAirport]").val();
	var fromAirportId = $("[name=fromAirportId]").val();
	var toAirportId = $("[name=toAirportId]").val();
	var fromAirportCity = $("[name=fromAirportCity]").val();
	var toAirportCity = $("[name=toAirportCity]").val();
	$("[name=fromAirport]").val(toAirport);
	$("[name=toAirport]").val(fromAirport);
	$("[name=fromAirportId]").val(toAirportId);
	$("[name=toAirportId]").val(fromAirportId);
	$("[name=fromAirportCity]").val(toAirportCity);
	$("[name=toAirportCity]").val(fromAirportCity);
}

function showList(flightType, index) {

	// $("#passengerCount").hide();
	$('#contraryProviderWarning').hide();

	var $trs = $trsMap[flightType];
	var checked = $("#showNonstop").prop("checked");
	if (checked)
		$trs = $trs.filter(".transferCount0");
	$trs.filter("[gr=a]").show();
	$trs.find("a.show").hide();
	for (flightType in flightOpen)
		flightOpen[flightType] = true;
}

function showDetails(index) {
	var $selectedFlight = $flightList.filter("[index=" + index + "]");
	var $selectedDetail = $selectedFlight.next();
	$selectedDetail.toggle();

	var visibleCount = $selectedDetail.filter(":visible").size();
	if (visibleCount == 1) {
		$selectedFlight.find("a.passiveDetail").removeClass("passiveDetail").addClass("activeDetail");
	} else {
		$selectedFlight.filter("[gr=a]").find("a.activeDetail").removeClass("activeDetail").addClass("passiveDetail");
	}
}


function clearCheckedItins(){
	
	$(".departureFlight").prop("checked",false);
	$(".returnFlight").prop("checked",false);
	
}



var providerRestrictionList = null;

function showOnurAir() {

	var answer = confirm("Se�ilen biletin sat��� sadece ONUR AIR websitesi �zerinden yap�lmaktad�r. \n\n ONUR AIR websitesine y�nlendirilmek i�in OK tu�una bas�n.");

	if (answer) {
		trackSearch('/OnurAirr', 1);

		var url = 'https://www.onurair.com.tr/secure/sales1.aspx?';
		window.open(url, 'onurAirWindow', winstatus);
	}

}

function checkTotalPax($button) {
	
	var providerKey = $button.attr("providerKey");

	var adult = $("#numAdult").val() !== undefined ? parseInt($("#numAdult").val()) : 0;
	var child = $("#numChild").val() !== undefined ? parseInt($("#numChild").val()) : 0;
	var infant = $("#numInfant").val() !== undefined ? parseInt($("#numInfant").val()) : 0;
	
	var military = $('#numMilitary').val() !== undefined ? parseInt($("#paxMilitary").val()) : 0;
	var student = $('#numStudent').val() !== undefined ? parseInt($("#paxStudent").val()) : 0;
	var senior = $('#numSenior').val() !== undefined ? parseInt($("#paxSenior").val()) : 0;
	var young = $('#numYoung').val() !== undefined ? parseInt($("#paxYoung").val()) : 0;

	var totalPax = adult + child + infant + military + student + senior + young;
	var paxLimit = 9;
	if (providerKey == 'TravelFusion') {
		paxLimit = 4;
	}else if (providerKey == 'THY' || providerKey == 'THY DOM' || providerKey == 'THY B2C') {
		paxLimit = 7;
	}
	if (totalPax > paxLimit)
		return paxLimit;
	else
		return 0;
}

function isLastHourFlight($button) {
	
	var departureDate = parseTRDate($button.attr("firstlegdeparture"));
	var now = new Date();
	var anHourLater = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours()+1, now.getMinutes());
	
	if (departureDate < anHourLater)
		return true;
	else
		return false;
}

function checkPassenger() {

	var adult = $("#numAdult").val();
	var child = $("#numChild").val();
	var infant = $("#numInfant").val();
	
	var military = $('#numMilitary').val();
	var student = $('#numStudent').val();
	var senior = $('#numSenior').val();
	var young = $('#numYoung').val();

	var totalPax = parseInt(adult) + parseInt(child) + parseInt(infant) + parseInt(military) + parseInt(student) + parseInt(senior) + parseInt(young);
	var cntNonFlyingAloneINF = 0;
	var cntNonFlyingAlonePax = 0;

	var providerId = $('input[name=itinarary_departure]:checked').attr("providerid");
	
	var flightdeparture = $('input[name=itinarary_departure]:checked').attr("flightdeparture");
	var flightarrival = $('input[name=itinarary_departure]:checked').attr("flightarrival");

	var faretype = $('input[name=itinarary_departure]:checked').attr("faretype");

	if(providerDefMap[providerId] == null)
		setProvidersPassengers(providerId, flightdeparture, flightarrival, faretype);
	
	if(providerDefMap[providerId] != null){
		
		if (!providerDefMap[providerId].isChildFlyingAlone)
			cntNonFlyingAlonePax = parseInt(cntNonFlyingAlonePax) + parseInt(child);
		
		if (!providerDefMap[providerId].isInfantFlyingAlone)
			cntNonFlyingAloneINF = parseInt(cntNonFlyingAloneINF) + parseInt(infant);
			
	} else {
		cntNonFlyingAlonePax = parseInt(child);
		cntNonFlyingAloneINF = parseInt(infant);
	};

	if (parseInt(cntNonFlyingAloneINF) > (totalPax - cntNonFlyingAlonePax - cntNonFlyingAloneINF))
		return false;

	if (cntNonFlyingAlonePax > 0 && (totalPax - cntNonFlyingAloneINF - cntNonFlyingAlonePax) < 1)
		return false;

	return true;

}

function checkForSearchFlight(collapse) {

	if($("#fromAirport").val() == "" || $("#toAirport").val() == "") {
		alert(FmtMessage.getMessage('js.flight.search.empty.city.warning'));
		return;
	}

	if($("#fromAirportCity").val() && $("#fromAirportCity").val() ==  $("#toAirportCity").val()) {
    	alert(FmtMessage.getMessage('js.flight.search.warning'));
    	return;
    }

	$("#isSearchFormCollape").val("1");

	var adult = $("#paxADT").val();

	var child = $("#paxCHD").val();
	var infant = $("#paxINF").val();
	
	var military = $('#paxMilitary').val();
	var student = $('#paxStudent').val();
	var senior = $('#paxSenior').val();
	var young = $('#paxYoung').val();
	
	military = (military === undefined) ? 0 : military;
	student = (student === undefined) ? 0 : student;
	senior = (senior === undefined) ? 0 : senior;
	young = (young === undefined) ? 0 : young;
	
	var totalAdult = parseInt(adult) + parseInt(military) + parseInt(student) + parseInt(senior) + parseInt(young);
	var totalPax = totalAdult + parseInt(child) + parseInt(infant);

	if (totalPax < 1) {
		alert(FmtMessage.getMessage('js.search.warning.1pax'));
	} else if (totalAdult < 1) {
		alert(FmtMessage.getMessage('js.search.warning.1adult'));
	} else if (totalAdult < infant) {
		alert(FmtMessage.getMessage('js.search.warning.infant.adult'));
	} else if (totalPax > 9) {
		alert(sprintf(FmtMessage.getMessage('js.search.warning.paxcount'), 9));
	} else {
		var formValid = $("#searchForm").valid();
		if (formValid) {
			openFlightLoaderBox();

			var searchUrl = URL_MAPPING.resolveUrl('/searchFlights');
			
			var url = trackSearch(searchUrl, totalPax);
			document.searchForm.action = url;
			document.searchForm.submit();
		}
	}
}


function trackSearch(url1, totalPax) {
	try {

//		var fromAirport = $('#fromAirport').val();
//		var toAirport = $('#toAirport').val();
//
//		if (fromAirport) {
//			fromAirport = fromAirport.split(" ")[0];
//		}
//
//		if (toAirport) {
//			toAirport = toAirport.split(" ")[0];
//		}
//
//		var url = url1 + "/"+ fromAirport + "/" + toAirport;
//
//		url += '/' + $('#departureDate').val().substr(0, 10);
//
//		var renabled = $('#returnDate').attr('disabled');
//		if (renabled != 'disabled') {
//			url = url + '/' + $('#returnDate').val().substr(0, 10);
//		}
//
//		url = url + '/' + totalPax;

		return url1;

	} catch (e) {

	}
}

function checkFreeSeat($button) {

	// BTOC-2882 bir ust siniftan ucus onerildigi icin kontrol kapatildi
	return true;
	
	var adult = $("#paxADT").val();
	var child = $("#paxCHD").val();

	// BTOC-1348
	// var student = $("#numSTUDENT").val();
	// var military = $("#numMILITARY").val();
	// var senior = $("#numSENIOR").val();
	// var young = $("#numYOUNG").val();
	// var totalPax = parseInt(adult) + parseInt(child) + parseInt(student) + parseInt(military) + parseInt(senior) + parseInt(young);

	var totalPax = parseInt(adult) + parseInt(child);

	var departureFreeSeat = $button.attr("freeSeats");
	var arrivalFreeSeat = $button.attr("returnFreeSeats");

	var minFreeSeat = departureFreeSeat;
	if (!isNaN(arrivalFreeSeat) && parseInt(departureFreeSeat) > parseInt(arrivalFreeSeat)) {
		minFreeSeat = arrivalFreeSeat;
	}

	if (parseInt(minFreeSeat) == 0) {
		return true;
	} else if (parseInt(minFreeSeat) < totalPax) {
		return false;
	} else {
		return true;
	}

}

function checkReturnFlightTime($button) {
	var departureFlightArrival = parseTRDate($button.attr("lastLegArrival"));
	var returnFlightDeparture = parseTRDate($button.attr("rFirstLegDeparture"));

	if (returnFlightDeparture <= departureFlightArrival) {
		return false;
	} else {
		return true;
	}
}


function parseTRDate(dateString) {
	var parts = dateString.split(' ');
	var dateParts = parts[0].split('.');
	var timeParts = parts[1].split(':');

	var date = new Date(dateParts[2], parseInt(dateParts[1], 10) - 1, dateParts[0], timeParts[0], timeParts[1], timeParts[2]);

	return date;
}
